export const HowLongDoesTheLifetimeWarrantyLast = () => {
  return (
    <div className='personalContent mx-auto mt-[20px] flex flex-col flex-col-reverse bg-[#f8f8f8] lg_mt-[80px] lg_h-[400px] lg_flex-row lg_px-0 '>
      <div className='flex flex-col  items-start justify-start px-[12px] lg_basis-1/2 lg_px-[40px] lg_pt-[75px]'>
        <h2 className='pb-[10px] font-teko-medium text-[28px] uppercase  leading-[30px] lg_pb-[20px] lg_pr-[40px] lg_text-[40px] lg_leading-[40px]'>
          How Long Does the Lifetime Warranty Last?
        </h2>

        <p className='mb-[10px] font-roboto-light text-[16px] font-light leading-[26px] lg_mb-[20px]'>
          The Lifetime Warranty lasts for the useful life of the product. While we stand behind the durability of our
          boots, it’s important to note that all well-used products will eventually wear out.
        </p>
        <p className='mb-[20px] font-roboto-light text-[16px] font-light leading-[26px]'>
          Please note that coverage ends if the product is refunded, sold, or transferred to another party.
        </p>
      </div>

      <div
        className='bg-cover mb-[20px] aspect-[375/200] lg_mb-0 lg_aspect-auto lg_h-full lg_basis-1/2'
        style={{
          backgroundImage: 'url(/warranty-page/lefttime-last.webp?v=1.0.0)',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        {/* <Image
          src={'/warranty-page/lefttime-last.webp?v=1.0.0'}
          width={550}
          height={400}
          quality={100}
          alt='lefttime-last'
          className='h-full w-full object-contain lg_h-[400px] lg_w-[550px]'
        /> */}
      </div>
    </div>
  );
};
